import { CashbackProcessadoPorCliente, Importacao, ItemDeImportacao, Page, Voucher } from '@/models';
import { AxiosRequestConfig } from 'axios';
import { Inject } from 'inversify-props';
import type { ImportacaoServiceAdapter } from "./adapter";



export class FindImportacaoUseCase {
	@Inject('ImportacaoServiceAdapter')
	private importacaoServiceAdapter!: ImportacaoServiceAdapter

	find = async (params?: any, config?: AxiosRequestConfig): Promise<Page<Importacao>> => 
		await this.importacaoServiceAdapter.find(params, config)

	findItens = async (params?: any, config?: AxiosRequestConfig): Promise<Page<ItemDeImportacao>> =>
		await this.importacaoServiceAdapter.findItens(params, config)

	findAllItens = async (params?: any, config?: AxiosRequestConfig): Promise<ItemDeImportacao[]> =>
		await this.importacaoServiceAdapter.findAllItens(params, config)

	baixarXmls = async (idImportacao: string, config?: AxiosRequestConfig): Promise<any> =>
		await this.importacaoServiceAdapter.baixarXmls(idImportacao, config);

	podeGerarDownloadCompleto = async (lojaId: string, config?: AxiosRequestConfig): Promise<boolean> =>
		await this.importacaoServiceAdapter.podeGerarDownloadCompleto(lojaId, config); 

	possuiImportacoesEmAbertoNoUsuarioLogado = async (usuarioId: string, config?: AxiosRequestConfig): Promise<boolean> =>
		await this.importacaoServiceAdapter.possuiImportacoesEmAbertoNoUsuarioLogado(usuarioId, config);

	findCashbacksProcessadosByImportacaoId = async (idImportacao: string, config?: AxiosRequestConfig): Promise<Voucher[]> =>
		await this.importacaoServiceAdapter.findCashbacksProcessadosByImportacaoId(idImportacao, config);

	findCashbacksProcessadosAgrupados = async (idImportacao: string, incluirDobro: boolean, config?: AxiosRequestConfig): Promise<CashbackProcessadoPorCliente[]> =>
		await this.importacaoServiceAdapter.findCashbacksProcessadosAgrupados(idImportacao, incluirDobro, config);

}